/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import LazyLoad from 'react-lazyload';
import Select from 'react-select';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import MusicCardContainer from '../../musics/containers/MusicCardContainer';
import Placeholder from '../../../common/placeholder/Placeholder';

const headerTagsJson = require('./headertags.json');

const Top10PageComponent = ({ slug, dataCategories, isLoading, dataTop10, withCategory, notFound, getTop10DataIfNeeded }) => {
    const [currentSlug, setCurrentSlug] = useState(slug || 'antena-1');

    useEffect(() => {
        animateScrollTo(0, { speed: 700 });

        getTop10DataIfNeeded(slug);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function mapTop10() {
        if (isLoading) {
            const myLoaderToTop10 = [];

            for (let i = 1; i <= 10; i += 1) {
                myLoaderToTop10.push(
                    <article key={i} className="musicItem">
                        <Placeholder minHeight="100%" />
                    </article>,
                );
            }

            return myLoaderToTop10;
        }

        return dataTop10.map((data, index) => {
            const position = index + 1;

            return (
                <LazyLoad key={position} offset={500} once className="top10Items">
                    <MusicCardContainer
                        music={data}
                        key={data.musicId}
                        playlistType={`top10-${currentSlug}`}
                        playlistData={dataTop10}
                        musicIndex={position}
                    />
                </LazyLoad>
            );
        });
    }

    function _showCategoryDescription() {
        if (withCategory && dataCategories) {
            return dataCategories.map((data) => {
                if (data.categorySlug === currentSlug) {
                    return (
                        <h1 key={data.categoryName}>
                            {data.description}
                        </h1>
                    );
                }

                return false;
            });
        }

        return false;
    }

    function metaTags(headerTags) {
        if (withCategory) {
            return (
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
            );
        }

        return false;
    }

    const title = currentSlug !== 'antena-1' ? currentSlug.toUpperCase() : 'ANTENA 1';
    const headerTags = {
        title: `As 10+ ${title} - Ranking das músicas da rádio`,
        meta: {
            description: `Confira o ranking das 10 músicas ${title} mais pedidas da programação pelos ouvintes.`,
            keywords: headerTagsJson[currentSlug] && headerTagsJson[currentSlug].keywords,
            'og:title': `As 10+ ${title} - Ranking das músicas da rádio`,
            'og:description': `Confira o ranking das 10 músicas ${title} mais pedidas da programação pelos ouvintes.`,
            'og:image': 'https://a1media.antena1.com.br/image/share/as-10-mais.png',
        },
    };

    if (notFound) {
        return (
            <ErrorPage
                errorNumber={404}
                backLink="/as-10-mais"
                title="NÃO ENCONTRAMOS ÁLBUNS PARA ESTA CATEGORIA :("
                message="Mas  temos  vários outros."
                buttonText="Clique aqui para ver outras 10 mais"
            />
        );
    }

    const customStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#d1d5db',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#d1d5db',
            },
        }),
        indicatorSeparator: () => ({
            color: 'transparent',
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '8px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }),
        option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected ? '#F2F4F7' : isFocused ? '#F2F4F7' : '#fff',
            color: '#000',
            padding: '10px',
        }),
    };

    const categoryOptions = dataCategories.map((item) => ({
        label: item.categoryName,
        value: item.categorySlug,
    }));

    const selectedCategory = categoryOptions.find((opt) => opt.value === currentSlug);

    return (
        <section className="Top10Page">
            <div>
                {metaTags(headerTags)}
                <header className="tw-text-center">
                    <h2>As 10 + da Antena 1</h2>
                    <p>No destaque da semana trazemos as 10 mais pedidas pelos ouvintes!</p>
                </header>

                <div className="containerSelectCategory">
                    <Select
                        instanceId="top10-category-select"
                        styles={customStyles}
                        value={selectedCategory}
                        options={categoryOptions}
                        onChange={(selected) => {
                            setCurrentSlug(selected.value);

                            getTop10DataIfNeeded(selected.value);

                            animateScrollTo(0, { speed: 700 });
                        }}
                        placeholder="Filtrar por categoria"
                    />
                </div>

                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-10">
                    {mapTop10()}
                </div>
            </div>
        </section>
    );
};

Top10PageComponent.propTypes = exact({
    slug: PropTypes.string,
    getTop10DataIfNeeded: PropTypes.func,
    dataTop10: PropTypes.arrayOf(PropTypes.object),
    dataCategories: PropTypes.arrayOf(PropTypes.object),
    withCategory: PropTypes.bool,
    notFound: PropTypes.bool,
    isLoading: PropTypes.bool,
});

export default Top10PageComponent;
